import roles from '@/constants/roles';

/** Every role that can open the CRM: all but operator and financial administrator (AQ-11066). */
export const CRM_ROLES: readonly string[] = [
    roles.ADMINISTRATOR.value,
    roles.MANAGER.value,
    roles.SALES_MANAGER.value,
    roles.SALES_REPRESENTATIVE.value,
    roles.SERVICE_TECHNICIAN.value,
    roles.LABORATORY_MANAGER.value,
    roles.LABORATORY_MICROBIOLOGIST.value,
    roles.LABORATORY_TECHNICIAN.value,
    roles.LABORATORY_CHEMIST.value,
];

/** These roles see every pipeline; the others only the pipelines granted in CRM access. Mirrors crm_service. */
export const ALL_PIPELINES_ROLES: readonly string[] = [roles.ADMINISTRATOR.value, roles.MANAGER.value];
